/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

import React from 'react';
import { Col, Row } from 'react-bootstrap';

export interface ITextCompProps {
  data?: string | string[];
}
export const TextComp = (props: ITextCompProps) => {
  const { data } = props;

  const _renderDescription = () => {
    if (data && !Array.isArray(data) && typeof (data === 'string')) {
      return <p className="fs-6 text-dark mb-0 w-100 align-justify">{data}</p>;
    }
    if (Array.isArray(data)) {
      return (
        <>
          {data?.map((str: string, index: number) => {
            return (
              <>
                <p
                  className="fs-6 text-dark mb-0 w-100 align-justify"
                  key={`list-${index}`}
                >
                  {str}
                </p>
                <br />
              </>
            );
          })}
        </>
      );
    }
    return null;
  };

  return (
    <Row className="pb-3 pt-2">
      <Col xs="auto" className="px-3">
        {_renderDescription()}
      </Col>
    </Row>
  );
};

TextComp.defaultProps = {
  data: '',
};
